module.exports = __webpack_public_path__ + "static/media/hans-profile-2019.467e4bad.jpg";